import React, { memo, useCallback, Fragment, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'

import Form from 'Components/Form'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import SubmitButton from 'Components/Form/SubmitButton'

import { number, required } from 'Utils/Validators/formValidation'
import Note from '../../../../Components/Note'
import { convertCentsToUnits } from '../../../../shared/libraries/finance'
import {
  AMBASSADOR_PER_MISSION,
  CAMPAIGN_ENUM_TYPES,
  HOURS_PER_MISSION,
} from '../../../../shared/constants'

const EditCityPlanPaymentsAndCostsFormUnstyled = props => {
  const {
    className,
    onSubmit,
    campaign,
    teamLeaderEnabled,
    teamLeaderPayAdjustment,
    payout,
    hourlyPayout,
    distributionCost,
    clientMarginPercent,
  } = props
  const [missionType, setMissionType] = useState(
    !!hourlyPayout ? HOURS_PER_MISSION : AMBASSADOR_PER_MISSION,
  )

  const handleFormUpdate = useCallback(
    (item, form) => {
      const { missionType } = form
      if (missionType && missionType.value) {
        setMissionType(missionType.value)
      }
    },
    [missionType],
  )

  const handleFormSubmit = useCallback((form, isValid) => {
    if (isValid) {
      const prettyFormData = {}
      for (const [key, value] of Object.entries(form)) {
        const valueNumber = Number(value.value)
        prettyFormData[key] = valueNumber ? valueNumber : value.value
      }
      onSubmit(prettyFormData)
    }
  }, [])

  return (
    <Form onUpdate={handleFormUpdate} onSubmit={handleFormSubmit}>
      <form className={className}>
        <SectionWrapper className="section-wrapper">
          <SectionTitle className="section-title">City Details</SectionTitle>
          <Grid container direction="row">
            <Grid display="flex">
              {CAMPAIGN_ENUM_TYPES[campaign.type] === 'LETTERBOX' && (
                <Grid>
                  <MissionTypeSelect initValue={missionType} />
                </Grid>
              )}
              {missionType === HOURS_PER_MISSION ? (
                <Fragment>
                  <Grid>
                    <HourlyPayoutInput initValue={hourlyPayout} />
                  </Grid>
                  <Grid>
                    <ClientMarginPercentInput initValue={clientMarginPercent} />
                  </Grid>
                </Fragment>
              ) : (
                <Fragment>
                  <Grid>
                    <PayoutInput initValue={payout} />
                  </Grid>
                  <Grid>
                    <DistributionCostInput initValue={distributionCost} />
                  </Grid>
                  <Grid>
                    <TeamLeaderPayAdjustment
                      teamLeaderEnabled={teamLeaderEnabled}
                      initValue={teamLeaderPayAdjustment}
                    />
                    <Note hidden={teamLeaderEnabled}>
                      Team Leader feature should be active on city level in
                      order to edit this field
                    </Note>
                  </Grid>
                </Fragment>
              )}
            </Grid>
          </Grid>
        </SectionWrapper>
        <SubmitButton className="submit-button" value="Save" />
      </form>
    </Form>
  )
}

EditCityPlanPaymentsAndCostsFormUnstyled.propTypes = {
  cities: PropTypes.array.isRequired,
}

const mapStateToProps = (state, props) => {
  const { cityPlan, city } = props
  return {
    payout: cityPlan.payout,
    clientMarginPercent: cityPlan.clientMarginPercent,
    hourlyPayout: cityPlan.hourlyPayout,
    distributionCost: cityPlan.distributionCost,
    teamLeaderPayAdjustment: convertCentsToUnits(
      cityPlan.teamLeaderPayAdjustment,
    ),
    teamLeaderEnabled: city.teamLeaderEnabled,
  }
}

const MissionTypeSelect = memo(({ initValue }) => (
  <SelectDashboard
    label="Mission Type"
    name="missionType"
    initValue={initValue}
    options={[
      {
        label: 'Per Mission',
        value: AMBASSADOR_PER_MISSION,
      },
      {
        label: 'Per Hour',
        value: HOURS_PER_MISSION,
      },
    ]}
  />
))

const PayoutInput = memo(({ initValue }) => (
  <Input
    name="payout"
    label="BA Surge Or Letterbox Payout (Per Mission)"
    placeholder="52"
    initValue={initValue}
    validator={[required, number]}
  />
))

const DistributionCostInput = memo(({ initValue }) => (
  <Input
    name="distributionCost"
    label="Distribution Cost For Customer (Per Mission)"
    initValue={initValue}
    placeholder="105"
    validator={[required, number]}
  />
))

const HourlyPayoutInput = memo(({ initValue }) => (
  <Input
    name="hourlyPayout"
    label="BA hourly pay"
    placeholder="10"
    initValue={initValue}
    validator={[required, number]}
  />
))

const ClientMarginPercentInput = memo(({ initValue }) => (
  <Input
    name="clientMarginPercent"
    label="Client Margin (%)"
    placeholder="5"
    initValue={initValue}
    validator={[required, number]}
  />
))

const TeamLeaderPayAdjustment = memo(({ initValue, teamLeaderEnabled }) => (
  <Input
    name="teamLeaderPayAdjustment"
    label="Team Leader Pay Adjustment (Per Mission)"
    placeholder="0"
    initValue={initValue}
    disabled={!teamLeaderEnabled}
    validator={[number]}
  />
))

export default connect(mapStateToProps)(
  EditCityPlanPaymentsAndCostsFormUnstyled,
)



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/EditCityPlanPaymentsAndCosts/unstyled.js